import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ApiClient } from './api-client.service';
import { ImpersonationStartRequest } from './impersonation-start-request';
import { ImpersonationStatus } from './impersonation-status';
import { ImpersonationStopRequest } from './impersonation-stop-request';
import { UIBlockingService } from './ui-blocking.service';
import { Router } from '@angular/router';


@Injectable()
export class ImpersonationService {

    readonly relativeBase = "super-admin-management/";

    impersonationStatus: Subject<ImpersonationStatus> = new BehaviorSubject<ImpersonationStatus>(new ImpersonationStatus());

    constructor(private http: ApiClient
        , private blockUI: UIBlockingService
        , private router: Router) {
    }

    beginImpersonation(contactId: string): Observable<ImpersonationStatus> {
        const request: ImpersonationStartRequest = { impersonating: true, impersonatedContactId: contactId };
        return this.http.put<ImpersonationStatus>(this.relativeBase + "impersonation", request);
    }
    endImpersonation(): Observable<ImpersonationStatus> {
        const request: ImpersonationStopRequest = { impersonating: false };
        return this.http.put<ImpersonationStatus>(this.relativeBase + "impersonation", request);
    }
}
